import React from 'react';
import { NavLink } from 'react-router-dom';
import './error.css';

const Error = () => {
  return (
    <section className="not-found-container" aria-label="Not-Found Page">
      <div className="not-found-content">
        <center>
          <h1>Page Not Found</h1>
          <h2>404</h2>
          <NavLink to="/" className="back-link">
            Go back to Home
          </NavLink>
        </center>
      </div>
    </section>
  );
};

export default Error;
